<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    id="vertical-nav"
    class="bg-white light print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="getNavigation()"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6 rounded-xl cursor-pointer
                    hover:scale-105 transition-all duration-250 ease-in-out delay-75"
                    [routerLink]="['/dashboard']">

            <div class="items-center cursor-pointer mr-4" [routerLink]="['/']">
                <img src="assets/images/logo/sting.png" class="h-8 w-auto object-contain" [alt]="'Company logo'" />
            </div>

        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full px-4">
            <!-- <div class="relative w-24 h-24">

                <mat-icon
                    class="icon-size-24"
                    [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </div> -->
            <!-- <div class="flex flex-col items-center justify-center w-full mt-6">
                <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{user.userName}} {{user.userName}}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{user.userName}}
                </div>
            </div> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div class="relative flex flex-0 items-center justify-between w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b
    bg-card dark:bg-transparent print:hidden">
        <span class="absolute text-secondary text-sm right-2 bottom-0.5">v{{version}}</span>

        <!-- Navigation toggle button -->


        <div class="relative flex flex-row items-center">
            <div *ngIf="isDevelopment" class="text-3xl font-semibold mr-3">DEV</div>
            <div *ngIf="isStage" class="text-3xl font-semibold mr-3">STAGE</div>
            <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
        </button>
        </div>

        <div class="flex items-center">

            <button *ngIf="isAdmin"
                class="mr-0 md:mr-4"
                mat-stroked-button
                (click)="openNotifWizard()">
                <i class="icon-size-4 far  fa-plus mr-1 -mb-1"></i>
                <span class="">{{'section.dashboard.new_notif' | translate}}</span>
            </button>

            <languages class="mr-2"></languages>
          <user [showAvatar]="false"></user>
        </div>

    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>

    </div>

</div>
